import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, CalendarDays, Armchair, Clock, Settings, LogOut, BookOpen, Percent, Image, Star, CreditCard, Cpu } from "lucide-react";

const LOGO_URL = "/logo-prenova.png";

export default function AdminSidebar() {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("admin_token");
        navigate("/admin/login");
    };

    const items = [
        { to: "/admin", label: "Panoramica", icon: LayoutDashboard, end: true },
        { to: "/admin/reservations", label: "Prenotazioni", icon: CalendarDays },
        { to: "/admin/reviews", label: "Recensioni", icon: Star },
        { to: "/admin/tables", label: "Tavoli", icon: Armchair },
        { to: "/admin/slots", label: "Slot Orari", icon: Clock },
        { to: "/admin/gallery", label: "Galleria", icon: Image },
        { to: "/admin/menu", label: "Menù", icon: BookOpen },
        { to: "/admin/discounts", label: "Sconti", icon: Percent },
        { to: "/admin/billing", label: "Fatturazione", icon: CreditCard },
        { to: "/admin/settings", label: "Impostazioni", icon: Settings },
        { to: "/admin/integrations", label: "API · SmartTable", icon: Cpu },
    ];

    return (
        <aside className="w-64 min-h-screen bg-ink-surface border-r border-white/10 flex flex-col" data-testid="admin-sidebar">
            <Link to="/admin" className="p-6 border-b border-white/10 flex items-center gap-3">
                <div className="w-12 h-12 rounded-sm overflow-hidden ring-1 ring-gold/40 bg-[#1a1f3a]">
                    <img src={LOGO_URL} alt="Prenova by Renova360" className="w-full h-full object-contain" />
                </div>
                <div>
                    <div className="font-serif text-lg text-white leading-none">Admin</div>
                    <div className="text-[9px] text-gold tracking-[0.2em] uppercase mt-1">Prenova by Renova360</div>
                </div>
            </Link>

            <nav className="flex-1 p-4 space-y-1">
                {items.map(({ to, label, icon: Icon, end }) => (
                    <NavLink key={to} to={to} end={end}
                        data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
                        className={({ isActive }) =>
                            `flex items-center gap-3 px-4 py-3 rounded-sm text-sm transition-colors
                            ${isActive ? "bg-gold/10 text-gold border-l-2 border-gold"
                                : "text-gray-400 hover:text-white hover:bg-white/5"}`
                        }>
                        <Icon size={16} strokeWidth={1.5} />
                        <span>{label}</span>
                    </NavLink>
                ))}
            </nav>

            <button onClick={handleLogout}
                className="m-4 flex items-center gap-3 px-4 py-3 text-sm text-gray-400 hover:text-red-400 hover:bg-red-500/5 rounded-sm transition-colors"
                data-testid="admin-logout-btn">
                <LogOut size={16} strokeWidth={1.5} />
                <span>Esci</span>
            </button>
        </aside>
    );
}
